/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversations_FailedInputs */



/**
* | output |
* | --- |
* | "We could not load your conversations. Please try again in a moment." |
*
* @param {Conversations_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const conversations_failed = /** @type {((inputs?: Conversations_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversations_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We konden je gesprekken niet laden. Probeer het zo meteen opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nous n'avons pas pu charger vos conversations. Réessayez dans un instant.")
	return /** @type {LocalizedString} */ ("We could not load your conversations. Please try again in a moment.")
});